import * as React from 'react';
import { Maybe, Promotion } from '@css-xp/graphtypes';
import { getReadablePromotionTitle, getReadablePromotionValue } from '@css-xp/base/entitlement-utils';

interface Props {
  scheduledPromotions?: Maybe<Promotion[]>;
  isStrike?: boolean;
}

const ScheduledPromotionChanges = ({ scheduledPromotions, isStrike }: Props): JSX.Element => {
  return (
    <>
      {(scheduledPromotions ?? []).map((scheduledPromotion: Promotion, index: number) => {
        return (
          <table key={index} className={isStrike ? 'strike' : ''}>
            <tbody>
              <tr className="scheduled-title">
                <td>{getReadablePromotionTitle(scheduledPromotion)}</td>
              </tr>
              <tr className="scheduled-value">
                <td>{getReadablePromotionValue(scheduledPromotion)}</td>
              </tr>
            </tbody>
          </table>
        );
      })}
    </>
  );
};

export default ScheduledPromotionChanges;
